<template>
  <div>
    <LoadingComponent v-show="pageLoading"></LoadingComponent>
    <div class="answer" v-if="list.length">
      <div class="top">
        <div class="item">{{ index + 1 }}/{{ list.length }}</div>
        <div class="item">{{ countdownText }}</div>
      </div>
      <div class="team" v-if="pkarea && pkinstitution && activityData.isShowTeamPK">
        <div class="team-left">
          <img src="https://yunyingcdn.thecover.cn/o_1haopepbd1n3v1msq1122a5v1d1d9.svg" class="win-img" alt="" v-if="winTeam.state === 0">
          {{ area + institution }}
        </div>
        <img src="@/assets/images/contestanswers/vs.png" class="vs-img" alt="">
        <div class="team-right">
          <img src="https://yunyingcdn.thecover.cn/o_1haopepbd1n3v1msq1122a5v1d1d9.svg" class="win-img" alt="" v-if="winTeam.state === 1">
          {{ pkarea + pkinstitution }}
          <div v-if="winTeam.state === 1">成绩：{{ winTeam.score }}分</div>
        </div>
      </div>
      <div class="swiper swiper-no-swiping">
        <div class="swiper-wrapper">
          <div class="swiper-slide" :style="`padding-top: ${ (pkarea && pkinstitution && activityData.isShowTeamPK) ? 54 : 22 }vw;`" v-for="item in list" :key="item.id">
            <img class="answer-option-img" :src="item.file" alt="" v-if="item.file">
            <div class="title" :style="`${ isSelectTitle ? '' : 'user-select: none;' } color: ${ activityData.themeColorTitle || 'white' };`">
              【{{ typeText[item.type] }}】{{ item.title }}
              <span :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" v-if="isViewNews && item.info && item.info.news_id" @click="handleViewNews(item.info)">
                <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4437" width="1024" height="1024"><path d="M306.05312 361.6768a61.44 61.44 0 0 1 4.21888 82.20672l-4.21888 4.66944-106.9056 106.9056a190.464 190.464 0 0 0 262.30784 276.15232l7.08608-6.7584 106.9056-106.9056a61.44 61.44 0 0 1 91.09504 82.24768l-4.21888 4.66944-106.9056 106.9056A313.344 313.344 0 0 1 104.448 476.61056l7.7824-8.11008 106.9056-106.9056a61.44 61.44 0 0 1 86.91712 0z m385.024-27.81184a61.44 61.44 0 0 1 4.21888 82.20672l-4.21888 4.66944-270.336 270.336a61.44 61.44 0 0 1-91.09504-82.20672l4.21888-4.66944 270.336-270.336a61.44 61.44 0 0 1 86.8352 0z m220.65152-221.5936a313.344 313.344 0 0 1 7.7824 435.07712l-7.7824 8.11008-106.9056 106.9056a61.44 61.44 0 0 1-91.09504-82.24768l4.21888-4.66944 106.9056-106.9056a190.464 190.464 0 0 0-262.30784-276.15232l-7.08608 6.7584-106.9056 106.9056a61.44 61.44 0 0 1-91.09504-82.24768l4.21888-4.66944 106.9056-106.9056a313.344 313.344 0 0 1 443.1872 0z" fill="#ffffff" p-id="4438"></path></svg>
                相关新闻
              </span>
            </div>
            <div class="options">
              <div class="item" :style="answers[index][i] ? `background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };` : ''" v-for="(info, i) in item.options" :key="info" @click="handleOption(i)"><span v-if="item.type !== 'judge'">{{ String.fromCharCode(65 + i) }}.</span>{{ info }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn">
        <button :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" @click="handlePrevPage" v-if="!(list[index].answer && list[index].answer.length) && index">上一题</button>
        <button :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" @click="handleNextPage" v-if="(list[index].answer || (index + 1) < list.length) && !isSubmit">下一题</button>
        <button :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" @click="handleSubmit" v-if="(!list[index].answer && (index + 1) === list.length) || isSubmit">提交</button>
      </div>
    </div>
    <div class="result" v-show="result" @click="handleCloseResult">
      <img src="@/assets/images/contestanswers/success.png" class="success" alt="恭喜答对了！" v-if="result === 1">
      <img src="@/assets/images/contestanswers/fail.png" class="success" alt="答错了" v-if="result === 2">
      <div class="result-tip" v-if="result === 2 && list[index].type !== 'judge'">
        正确答案：<span v-for="item in list[index].answer" :key="item">{{ String.fromCharCode(65 + item) }}</span>
        <p v-for="item in list[index].answer" :key="item">{{list[index].options[item]}}</p>
      </div>
    </div>
    <div class="end" v-if="score !== null">
      <div class="end-title" :style="`color: ${ activityData.themeColor || '#FB7A43' };`">{{ (lotteryLink && activityData.lotteryNotice) ? activityData.lotteryNotice : '答 题 结 束' }}</div>
      <div class="end-score" :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`">成绩：<span>{{ score }}分</span></div>
      <div class="action" style="width: 72vw;" v-if="activityData.actionShow && activityData.actionShow.includes('rank') || studyLink">
        <div class="rank" :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" v-if="activityData.actionShow.includes('rank')" @click="handleRank">
          <img src="../../../assets/icon/rank.svg" alt="">
          排行榜
        </div>
        <div class="rank" :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" v-if="studyLink" @click="handleStudy">
          学习专区
          <img src="../../../assets/icon/home.svg" alt="">
        </div>
      </div>
      <div class="action" style="width: 72vw;" v-if="activityData.sharePosterBg || lotteryLink">
        <div class="rank" :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" v-if="activityData.sharePosterBg" @click="handleShare">
          <img src="../../../assets/icon/share.svg" alt="">
          分享成绩
        </div>
        <div class="rank" :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" v-if="lotteryLink && !activityData.lotteryNotice" @click="handlePirze">
          去抽奖
          <img src="../../../assets/icon/gift.svg" alt="">
        </div>
      </div>
    </div>
    <div class="share-score-img" v-if="shareScoreImg" @click="shareScoreImg = null">
      <span>长按图片保存</span>
      <img :src="shareScoreImg" alt="成绩">
    </div>
    <dialog-component :baseData="baseData"></dialog-component>
  </div>
</template>

<script>
import Swiper from "swiper/swiper-bundle.min";
import "swiper/swiper-bundle.css";
import { mapState, mapActions, mapMutations } from "vuex";
import COVER from "@/utils/COVER";
import LoadingComponent from '@/components/Loading'
import COVERAPP from '../../../utils/COVERAPP';
import DialogComponent from "@/components/Dialog";
import Config from "@/utils/config";

let session = ''
let swiper = ''
let cdint = ''
let teamInfo = {}  // 团队赛信息
let pkTeamInfo = {}  // PK团队的信息
let sessionEndTime = ''  // session 结束时间
let optionsAnswer = {};  // 正确选项排序数据集
let isLotteryOpen = false;  // 是否开启抽奖
let lotteryType = '';  // 抽奖方式
let lotteryLink = '';  // 抽奖链接
let lotteryValue = '';
let isStageLottery = false;  // 判断是否阶梯抽奖
let isSubmit = false;  // 是否正在提交答案
let originNotify = '';  // 来源通知
export default {
  name: 'answer',
  data() {
    return {
      aid: '',
      list: [],
      time: '',
      index: 0,
      answers: [],
      typeText: {
        radio: '单选题',
        check: '多选题',
        judge: '判断题'
      },
      pageLoading: false,
      result: 0,  // 答题结果
      isSubmit: false,
      score: null,
      countdownText: '00:00',
      area: '',
      institution: '',
      pkarea: '',
      pkinstitution: '',
      applyInfo: {}, //如果有报名则获取报名信息
      shareScoreImg: '',
      winTeam: {},  // 获胜队伍
      isSelectTitle: false,
      match: '',  // 抽题别名
      studyLink: '',  // 学习专区链接
      lotteryLink: '',  // 抽奖链接
      isViewNews: true,  // 是否查看相关新闻
    }
  },
  props: ["activityData"],
  computed: {
    ...mapState(["dialogData", "userinfo"]),
  },
  components: {
    LoadingComponent,
    DialogComponent,
  },
  created() {
    session = "";
    this.aid = this.$route.query.id || "";
    this.isSelectTitle = this.$route.query.isselecttitle || false;
    originNotify = this.$route.query.originNotify || '';
    const match = +this.$route.query.match || '';
    this.match = match;
    const area = localStorage.getItem('answer_area_' + this.aid) || null;
    const institution = localStorage.getItem('answer_institution_' + this.aid) || null;
    this.area = area;
    this.institution = institution;
    const that = this
    document.addEventListener('visibilitychange', function() { 
      if (!document.hidden) {
        that.handleTimeUpdate();
      }
    });

    let studyLink = '';
    switch (match) {
      case 1:
        studyLink = this.activityData.answerPerson.studyLink;
        isLotteryOpen = this.activityData.answerPerson.isLotteryOpen;
        lotteryType = this.activityData.answerPerson.lotteryType;
        lotteryLink = this.activityData.answerPerson.lotteryLink;
        lotteryValue = +this.activityData.answerPerson.lotteryValue;
        isStageLottery = this.activityData.answerPerson.lotteryOpenStage;
        break;
      case 2:
        studyLink = this.activityData.answerTeam.studyLink;
        isLotteryOpen = this.activityData.answerTeam.isLotteryOpen;
        lotteryType = this.activityData.answerTeam.lotteryType;
        lotteryLink = this.activityData.answerTeam.lotteryLink;
        lotteryValue = +this.activityData.answerTeam.lotteryValue;
        isStageLottery = this.activityData.answerTeam.lotteryOpenStage;
        break;
      case 3:
        studyLink = this.activityData.answerPk.studyLink;
        isLotteryOpen = this.activityData.answerPk.isLotteryOpen;
        lotteryType = this.activityData.answerPk.lotteryType;
        lotteryLink = this.activityData.answerPk.lotteryLink;
        lotteryValue = +this.activityData.answerPk.lotteryValue;
        isStageLottery = this.activityData.answerPk.lotteryOpenStage;
        break;
    }

    this.studyLink = studyLink;

    // 查看相关新闻计算
    if (this.activityData.isViewNoneNews || !COVERAPP.Attribute.isApp()) {
      this.isViewNews = false;
    }
  },
  mounted() {
    COVER.yunTrack(this.aid, "load");
    const _this = this;
    if (!this.userinfo || !this.userinfo.token) {
      COVER.getUser((res) => {
        const userinfo = JSON.parse(JSON.stringify(res));
        if (userinfo && userinfo.token) {
          _this.setUserinfo(userinfo);
          _this.$nextTick(() => {
            _this.getSubject();
          });
          return;
        }

        _this.$router.back();
      });

      return;
    }
    this.getSubject();
    // this.getApplyInfo()
  },
  beforeDestroy() {
    clearInterval(cdint);
  },
  methods: {
    ...mapMutations(["setToastData", "setDialogData"]),
    ...mapActions(["setDialogDataAsync", "setUserinfo"]),
    getApplyInfo () {
        if (this.activityData.applyTime) {
            COVER.$get('/apply/token', {
                aid: this.aid,
                token: this.userinfo.token || ''
            }).then((res) => {
                if (res.errno == 0 && res.data && res.data._id) {
                    this.applyInfo = res.data.info
                }
            }).catch(err => {
                this.getApplyInfo()
            })
        }
    },
    getSubject() {
      this.pageLoading = true;
      let param = {
        aid: this.aid,
        userinfo: this.userinfo,
        label: this.$route.query.label
      };
      COVER.$post("/answer/subject?match=" + (this.match || 0), param).then((res) => {
        this.pageLoading = false;
        if (this.match === 2) {
          this.getTeam();
        }
        if (res.errno === 0) {
          const list = res.data.list || [];
          session = res.data.session;
          const times = res.data.times;
          this.time = times;
          list.forEach(item => {
            // 如果没有返回答案，则对选项进行乱序处理
            if (!item.answer) {
              const options = item.options;
              let opts = JSON.parse(JSON.stringify(options));
              opts.sort(() => {
                return Math.random() - 0.5;
              });
              let right = [];
              opts.forEach(oitem => {
                options.forEach((aitem, index) => {
                  if (oitem === aitem) {
                    right.push(index);
                  }
                });
              });
              optionsAnswer[item.id] = right;
              item.options = JSON.parse(JSON.stringify(opts));
            }
            this.answers.push([]);
          });
          this.list = list;
          sessionEndTime = new Date().getTime() + (times * 1000);
          this.$nextTick(() => {
            this.slide();
            this.countdown();
          })
          return;
        }

        this.setToastData({
          text: res.errmsg ||  "网络错误~",
        });
      }).catch(err => {
        this.setToastData({
          text: "网络错误~",
        });
      });
    },
    // 获取团队
    getTeam() {
      COVER.$post('/answer/team/pkname', {
        aid: this.aid,
        userinfo: this.userinfo,
        teamname: this.area + this.institution,
      }).then(res => {
        if (res.errno === 0) {
          this.pkarea = res.data.area;
          this.pkinstitution = res.data.institution;
          pkTeamInfo = res.data || {};
        }
      });
    },
    slide() {
      const _this = this;
      swiper = new Swiper('.swiper', {
        autoHeight: true,
        on: {
          slideChange(e) {
            _this.index = e.activeIndex;
          },
        },
      })
    },
    handlePrevPage() {
      swiper.slidePrev();
    },
    handleNextPage() {
      const list = this.list;
      const index = this.index;
      const answers = this.answers;
      // 如果有返回答案，需判断是否有作答
      const asinfo = answers[index] || [];
      const option = [];
      asinfo.forEach((item, index) => {
        if (item) {
          option.push(index);
        }
      });
      if (list[index].answer && !option.length) {
        this.setToastData({
          text: "请先选择答案~",
        });
        return;
      }

      // 如果有返回答案，需提示
      if (list[index].answer) {
        if (list[index].answer.sort().join(',') === option.sort().join(',')) {
          this.result = 1;
          return;
        }

        this.result = 2;
        return;
      }

      swiper.slideNext();
    },
    handleOption(i) {
      const index = this.index;
      const list = this.list;
      let answer = this.answers[index];

      if (this.isSubmit && answer.length) {
        return;
      }

      if (list[index].type !== 'check') {
        answer = [];
      }

      answer[i] = !answer[i];
      this.$set(this.answers, index, answer);
    },
    handleTimeUpdate() {
      const _this = this;
      const nowTimes = new Date().getTime();
      const times = Math.floor((sessionEndTime - nowTimes) / 1000);
      this.time = times;
      this.countdown();

      if (times === 0) {
        this.submit();
      }

      if (times < 0) {
        this.time = 0;
        clearInterval(cdint);
        this.countdownText = '00:00';
        this.setDialogDataAsync({
          message: "本次答题因超时已中断，请重新开始答题吧。",
          btns: [
            {
              text: "取消",
              className: "close-btn",
            },
            {
              text: "确定",
              className: "share-btn",
              callback() {
                _this.$router.back();
              },
            },
          ],
        });
        return;
      }
    },
    handleSubmit() {
      const _this = this;
      const { none } = this.answerCount();
      this.setDialogDataAsync({
        message: (none ? `还有${ none }道题未作答，是否要提交答案？` : (this.activityData.answerSubmitMessage || '是否要提交答案？')),
        btns: [
          {
            text: "取消",
            className: "close-btn",
          },
          {
            text: "确定",
            className: "share-btn",
            callback() {
              _this.submit();
            },
          },
        ],
      });
      /* const is = confirm(none ? `还有${ none }道题未作答，是否要提交答案？` : '是否要提交答案？');
      if (is) {
        this.submit();
      } */
    },
    // 获取答题信息
    answerCount() {
      const answers = this.answers || [];
      const list = this.list || [];
      let answer = {};
      let none = 0;  // 未作答数
      answers.forEach((item, index) => {
        let option = [];
        item.forEach((info, i) => {
          if (info) {
            option.push(list[index].answer ? i : optionsAnswer[list[index].id][i]);  // 如果接口未返回答案，则需对乱序题目映射成真实顺序序号
          }
        });
        if (!option.length) {
          none++;
        }
        answer[list[index].id] = option;
      });

      return {
        answer,
        none,
      }
    },
    // 提交答案
    submit() {
      if (isSubmit) {
        return;
      }
      const _this = this;
      clearInterval(cdint);
      const { answer } = this.answerCount();
      this.pageLoading = true;
      let info = Object.assign({}, this.applyInfo);
      const name = localStorage.getItem('answer_name_' + this.aid) || null;
      const phone = localStorage.getItem('answer_phone_' + this.aid) || null;
      const area = localStorage.getItem('answer_area_' + this.aid) || null;
      const institution = localStorage.getItem('answer_institution_' + this.aid) || null;
      const teamName = localStorage.getItem('answer_team_name_' + this.aid) || null;

      if (name) {
        info.name = name;
      }

      if (phone) {
        info.phone = phone;
      }

      if (area) {
        info.area = area;
      }

      if (institution) {
        info.institution = institution;
      }
      
      let param = {
        session,
        answer,
        info,
        aid: this.aid,
        userinfo: this.userinfo,
        match: this.match,
      }

      // 是否打开乱序选项的日志记录
      if (this.activityData.isOpenOptionsLogs) {
        param.oa = btoa(JSON.stringify(optionsAnswer));
      }
      
      // 若是团队赛，则传团队赛信息
      if (this.match === 2) {
        param.team = {
          name: teamName,
          pid: teamInfo.pid,
        };
      }

      isSubmit = true;
      COVER.$post("/answer/submit", param).then((res) => {
        isSubmit = false;
        this.pageLoading = false;
        if (res.errno === 2014) {
          this.setToastData({
            text: "已完成答题",
          });
          return;
        }

        if (res.errno === 2012) {
          this.setToastData({
            text: "参与人数已满",
          });
          return;
        }

        if (res.errno === 2013) {
          this.setToastData({
            text: "今日已答题",
          });
          return;
        }

        if (res.errno === 1001) {
          this.setDialogDataAsync({
            message: "本次答题已超时，重新开始答题吧。",
            btns: [
              {
                text: "确定",
                className: "share-btn",
                callback() {
                  _this.$router.back();
                },
              },
            ],
          });
          return;
        }

        if (res.errno !== 0) {
          return alert(res.errmsg || "网络错误~");
        }

        const { score, times, total } = res.data;
        // 如果开启了结果页定制，则跳转
        if (this.activityData.resultScoreUrl) {
          let url = this.activityData.resultScoreUrl.replace('{score}', score);
          // 添加来源通知
          if (originNotify) {
            url = url.replace('{originNotify}', originNotify);
          }
          window.location.replace(url);
          return;
        }
        
        this.score = score;

        // 判断团队赛获胜队伍
        let win = 0;
        // PK队伍的成绩超过自己
        if (pkTeamInfo.score > score) {
          win = 1;
        }

        // PK队伍成绩与自己相同，则根据耗时
        if (pkTeamInfo.score === score && times > pkTeamInfo.times) {
          win = 1;
        }
        this.winTeam = {
          state: win,
          score: win ? pkTeamInfo.score : score,
        }

        // 如果开启抽奖
        if (isLotteryOpen) {
          // 按照分数抽奖
          if (!isStageLottery && lotteryType === 'score' && score >= lotteryValue) {
            this.lotteryLink = lotteryLink;
            return;
          }

          // 按照数量抽奖
          if (!isStageLottery && lotteryType === 'count' && total >= lotteryValue) {
            this.lotteryLink = lotteryLink;
            return;
          }

          this.lotteryLink = '';
          // 如果是阶梯抽奖，则需要调用接口查询是否有抽奖资格
          if (isStageLottery) {
            COVER.$post("/answer/lottery/stage", {
              aid: this.aid,
              userinfo: this.userinfo,
              match: this.match,
            }).then(res => {
              if (res.errno === 0) {
                this.lotteryLink = res.data.link;
              }
            });
          }
        }
      }).catch(err => {
        isSubmit = false;
        this.setToastData({
          text: "网络错误~",
        });
      });
    },
    // 关闭结果页
    handleCloseResult() {
      this.result = 0;
      this.$nextTick(() => {
        if ((this.index + 1) === this.list.length) {
          this.isSubmit = true;
          return;
        }
        this.handleTimeUpdate();
        swiper.slideNext();
      });
    },
    handleStudy() {
      window.location.replace(this.studyLink);
    },
    // 倒计时
    countdown() {
      let time = this.time;
      if (time >= 0) {
        clearInterval(cdint);
        cdint = setInterval(() => {
          time--;
          if (time < 0) {
            clearInterval(cdint);
            this.submit();
            return;
          }
          const minute = Math.floor(time / 60);
          const second = time - minute * 60;
          this.countdownText = fmnum(minute) + ':' + fmnum(second);
          this.time = time;
        }, 1000);
      }

      function fmnum(n) {
        if (n < 10) {
          return '0' + n;
        }
        
        return n;
      }
    },
    handleRank() {
      this.$router.replace('rank?id=' + this.aid);
    },
    toRgba(c) {
      if (!c) {
        return;
      }
      return `linear-gradient(45deg, ${ COVER.hexToRgba(c, 0.7) }, ${ COVER.hexToRgba(c) })`;
    },
    handleShare() {
      COVER.yunTrack(this.aid, "click", {
        label: '分享成绩',
        match: this.match,
        score: this.score,
      });
      const _this = this;
      let nickname = this.userinfo.nickname;
      if (COVERAPP.Attribute.isApp() && COVERAPP.Attribute.isIOS()) {
        if (COVERAPP.Attribute.appVersion().split('.').join('') >= 450) {
          try {
            nickname = decodeURIComponent(escape(window.atob(nickname)))
          }
          catch(e) {}
        }
      }
      // 对nickname进行加*遮掩
      nickname = nickname.replace(/^(.{1}).*(.{1})$/, '$1**$2');
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = this.activityData.sharePosterBg;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        ctx.font = "bold 120px 黑体";
        ctx.textAlign="center";
        ctx.fillStyle=this.activityData.shareTextColor || "#A05050";
        ctx.fillText(this.score || 0, 640, 1260);
        ctx.font = "bold 48px 黑体";
        ctx.textAlign="center";
        ctx.fillStyle=this.activityData.shareTextColor || "#050708";
        ctx.fillText(nickname, 540, 1110);
        const imageData = canvas.toDataURL();
        if (COVERAPP.Attribute.isApp()) {
          COVERAPP.Method.shareImage({
            image: imageData.split(';base64,')[1],
            title: this.activityData.title,
            desc: this.activityData.title,
            callback() {
              COVER.yunTrack(_this.aid, "share", {
                label: '分享海报',
                match: _this.match,
                score: _this.score,
              });
            },
          });
          return;
        }
        _this.shareScoreImg = imageData;
      }
    },
    handlePirze() {
      COVER.yunTrack(this.aid, "click", {
        label: '去抽奖',
        match: this.match,
        score: this.score,
      });
      window.location.replace(this.lotteryLink);
    },
    handleViewNews(info) {
      COVER.yunTrack(this.aid, "click", {
        label: '相关新闻',
        match: this.match,
        ...info,
      });
      if (COVERAPP.Attribute.isApp()) {
        window.location.href = `${ Config.APP_SCHEME_URL }/news?id=${ info.news_id }&flag=1`
      }
    },
  },
}
</script>

<style lang="less" scoped>
.top {
  display: flex;
  justify-content: space-between;
  position: fixed;
  width: 100%;
  top: 7vw;
  left: 0;
  padding: 0 5.5vw;
  box-sizing: border-box;
  z-index: 5;
  .item {
    background: rgba(#302924, .3);
    color: white;
    font-size: 5.2vw;
    padding: 2vw 3vw;
    border-radius: 2vw;
  }
}
.title {
  font-size: 4.8vw;
  color: white;
  line-height: 1.5em;
  margin-bottom: 6.5vw;
  // user-select: none;
  span {
    font-size: 2.8vw;
    line-height: 3.6vw;
    padding: 1vw 1.5vw;
    box-sizing: border-box;
    border-radius: 2px;
    color: white;
    background: #1890FF;
    margin: 0.6vw 0 0 1vw;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    // width: 15vw;
    svg {
      width: 3.0vw;
      height: 3.0vw;
      margin-right: 0.5vw;
    }
  }
}
.options {
  display: flex;
  flex-direction: column;
  .item {
    width: 80%;
    display: flex;
    border-radius: 2vw;
    font-size: 4vw;
    font-weight: bold;
    justify-content: center;
    box-shadow: 0 1vw 2vw rgba(#000, .3);
    padding: 2vw 3vw;
    box-sizing: border-box;
    line-height: 1.6em;
    margin: 0 auto 4vw auto;
    background: #ABAAAA;
    user-select: none;
    cursor: pointer;
    span {
      margin-right: 2vw;
    }
  }
}
.btn {
  display: flex;
  position: fixed;
  bottom: 5vw;
  width: 100%;
  box-sizing: border-box;
  left: 0;
  padding: 0 10%;
  z-index: 5;
  button {
    width: 100%;
    display: flex;
    border-radius: 2vw;
    font-size: 4vw;
    font-weight: bold;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1vw 2vw rgba(#000, .3);
    padding: 2vw 3vw;
    box-sizing: border-box;
    line-height: 1.6em;
    color: white;
    outline: 0;
    border: 0;
    margin: 0 3vw;
  }
}
.swiper {
  height: 100%;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  .swiper-slide {
    padding: 55vw 5.5vw 20vw 5.5vw;
    box-sizing: border-box;
    height: 100vh;
    overflow: scroll;
  }
}
.result {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 6;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background: rgba(#000, .7);
  img {
    width: 40%;
  }
  .result-tip {
    color: white;
    font-size: 4.8vw;
    margin-top: 10vh;
    max-height: 50vh;
    // overflow: scroll;
    padding: 0 5vw;
    box-sizing: border-box;
    text-align: center;
    p {
        padding-top: 3vw;
    }
  }
}
.end {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 6;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background: rgba(#000, .7);
  .end-title {
    font-size: 8vw;
    font-weight: bold;
    margin-bottom: 7.5vw;
    text-align: center;
    padding: 0 5vw;
    box-sizing: border-box;
  }
  .end-score {
    width: 72vw;
    margin: 0 auto;
    font-size: 7vw;
    font-weight: bold;
    text-align: center;
    display: flex;
    height: 28vw;
    justify-content: center;
    align-items: center;
    border-radius: 3vw;
    margin-bottom: 7.5vw;
    span {
      font-size: 9vw;
    }
  }
}
.answer-option-img {
  width: 100%;
}
.team {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  color: white;
  font-size: 4.4vw;
  margin-top: 22vw;
  position: fixed;
  z-index: 7;
  .team-left {
    background: url('../../../assets/images/contestanswers/t_bg_l.png');
    background-size: 100% 100%;
    width: 51%;
    height: 29.16vw;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8vw 0 3vw;
    box-sizing: border-box;
    animation: tl .5s 0s ease forwards;
    transform: translateX(-30vw);
  }
  .vs-img {
    position: absolute;
    width: 8.4vw;
    height: 8.4vw;
    margin-left: 45.8vw;
    transform: scale(1.5);
    animation: vs .5s 0.1s ease forwards;
    z-index: 1;
  }
  .win-img {
    width: 30vw;
    position: absolute;
    animation: win .6s 0s ease forwards;
    transform: scale(2);
  }
  .team-right {
    background: url('../../../assets/images/contestanswers/t_bg_r.png');
    background-size: 100% 100%;
    width: 51%;
    height: 29.16vw;
    margin-left: -4vw;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 3vw 0 8vw;
    box-sizing: border-box;
    animation: tr .5s 0s ease forwards;
    transform: translateX(30vw);
    flex-direction: column;
    div {
      font-size: 3.2vw;
      line-height: 1.8em;
    }
  }
}
.share-score-img {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(#000, 0.8);
  z-index: 100;
  display: flex;
  flex-direction: column;
  color: white;
  align-items: center;
  line-height: 2.5em;
  justify-content: center;
  font-size: 3.4vw;
  img {
    height: 80vh;
    width: auto;
  }
}
@keyframes tl {
  0% {
    transform: translateX(-30vw);
  }
  100% {
    transform: translateX(0vw);
  }
}
@keyframes tr {
  0% {
    transform: translateX(30vw);
  }
  100% {
    transform: translateX(0vw);
  }
}
@keyframes vs {
  0% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes win {
  0% {
    transform: scale(2);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.7;
  }
}
</style>